exports.components = {
  "component---node-modules-adobe-gatsby-theme-aio-src-pages-404-md": () => import("./../../../node_modules/@adobe/gatsby-theme-aio/src/pages/404.md" /* webpackChunkName: "component---node-modules-adobe-gatsby-theme-aio-src-pages-404-md" */),
  "component---src-pages-api-v-1-md": () => import("./../../../src/pages/api/v1.md" /* webpackChunkName: "component---src-pages-api-v-1-md" */),
  "component---src-pages-api-v-2-md": () => import("./../../../src/pages/api/v2.md" /* webpackChunkName: "component---src-pages-api-v-2-md" */),
  "component---src-pages-index-md": () => import("./../../../src/pages/index.md" /* webpackChunkName: "component---src-pages-index-md" */)
}

